import React, { useState } from 'react'
import { MyModal } from '~/components/ui/MyModal'
import styled from 'styled-components'
import { Input } from 'antd'

import styles from './AIShareTitleModal.module.css'
import { MyBtn } from '~/components/ui/MyBtn'

const CustomMyModal = styled(MyModal)`
  .ant-modal-body {
    padding: 16px;
  }

  .ant-modal-close {
    display: none;
  }
`

export default function AIShareTitleModal({
  visible,
  setVisible,
  onSuccess,
}: {
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  onSuccess: (title: string) => void
}) {
  const [shareTitle, setShareTitle] = useState('')

  return (
    <CustomMyModal
      open={visible}
      title={null}
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={270}
      footer={null}
      // transitionName=""
      maskTransitionName=""
      centered
      dark
    >
      <div className="font-medium text-base mb-2 text-center text-neutral-800">
        分享图展示信息
      </div>
      <div className={styles.textArea}>
        <Input.TextArea
          maxLength={20}
          placeholder="自定义标题（可选）"
          showCount
          autoSize={{ minRows: 3 }}
          value={shareTitle}
          onChange={e => {
            setShareTitle(e.target.value.trim())
          }}
        />
      </div>
      <div className="flex gap-3 mt-4">
        <MyBtn
          $dark={true}
          className="flex-1"
          onClick={() => setVisible(false)}
        >
          取消
        </MyBtn>
        <MyBtn
          $dark={true}
          className="flex-1"
          type="primary"
          onClick={() => {
            onSuccess(shareTitle)
          }}
        >
          提交
        </MyBtn>
      </div>
    </CustomMyModal>
  )
}
